const { client, loadToken } = require('./client');
export { loadToken };

export async function getAllDevices() {
  var { data } = await client.get(`/api/devices`);

  return data;
}

export async function getDevice(uuid) {

  var { data } = await client.get(`/api/devices/${uuid}`);

  if (data.length) {
    return data[0];
  }
  else {
    return null;
  }
}

export async function updateDeviceData(data) {
  console.log(data);
  var { data } = await client.put(`/api/devices/${data.uuid}`, data);
  return data;
}

export async function getDevices(uuids) {
  var { data } = await client.get(`/api/devices/${uuids.join(',')}`);
  return data;
}

export async function reboot(uuid) {
  var { data } = await client.post(`/api/commands/${uuid}/reboot`);
  return data;
}

export async function eraseFlash(uuid) {
  var { data } = await client.post(`/api/commands/${uuid}/eraseFlash`);
  return data;
}

export async function setLights(uuid, front, back) {
  var { data } = await client.post(`/api/commands/${uuid}/setLights/${front}/${back}`);
  return data;
}

export async function getEvents(uuid, field, start_time, end_time, group_size) {
  var { data } = await client.get(`/api/events/${field}/${start_time}/${end_time}/${group_size}`);
  return data;
}

export async function getEventsByField(uuid, field, start_time, end_time, group_size) {
  var { data } = await client.get(`/api/events/v2/${uuid}/${field}/${start_time}/${end_time}/${group_size}`);
  return data;
}

export async function getLogs(uuid, field, start_time, end_time, group_size) {
  var { data } = await client.get(`/api/logs/${uuid}/${field}/${start_time}/${end_time}/${group_size}`);
  return data;
}

export async function setTTS(uuid, level) {
  var { data } = await client.put(`/api/tts/${uuid}/${field}/${level}`);
  return data;
}

export async function getLiveView(uuid) {
  var { data } = await client.get(`/api/liveview/${uuid}`, {
    responseType: 'arraybuffer'
  });
  return data;
}

export async function getLiveviewHistory(uuid, start_time, end_time) {
  var { data } = await client.get(`/api/liveview/history/${uuid}/${start_time}/${end_time}`);
  return data;
}

export async function getLiveviewHistoryImages(uuid, start_time, end_time) {
  var { data } = await client.get(`/api/liveview/history/images/${uuid}/${start_time}/${end_time}`);
  return data;
}

export async function getCameraFeed(uuid) {
  var { data } = await client.get(`/api/camera/image/${uuid}`, {
    responseType: 'arraybuffer'
  });
  return data;
}

export async function getCameraHistory(uuids, start_time, end_time) {
  var { data } = await client.get(`/api/camera/sites/${uuids}/${start_time}/${end_time}`);
  return data;
}

export async function getCameraImage(_id) {
  var { data } = await client.get(`/api/camera/${_id}`, {
    responseType: 'arraybuffer'
  });
  return data;
}

export async function getCameraObjectsHistory(uuids, start_time, end_time) {
  var { data } = await client.get(`/api/camera/objects/${uuids}/${start_time}/${end_time}`);
  return data;
}

export async function getLatestCameraObjects(uuids) {
  var { data } = await client.get(`/api/camera/objects/${uuids.join(',')}`);
  return data;
}

export async function getAggregatedCameraObjects(uuids, start_time, end_time, group_size) {
  var { data } = await client.get(`/api/camera/objects/aggregated/${uuids}/${start_time}/${end_time}/${group_size}`);
  return data;
}

const all = {
  loadToken, getAllDevices, getDevice, updateDeviceData, getDevices, reboot, eraseFlash, setLights, getEvents, getEventsByField, getLogs, setTTS, getLiveView, getCameraFeed, getCameraHistory, getCameraImage, getLatestCameraObjects, getCameraObjectsHistory, getAggregatedCameraObjects
};

export default all;